/** Raiz das telas do módulo: menu `automacoes`, módulo `automacoes`. */
export const BASE = '/automacoes/automacoes';

export type Area = 'fiscal' | 'dp' | 'bpo' | 'legalizacao' | 'ti';
export const AREAS: Area[] = ['fiscal', 'dp', 'bpo', 'legalizacao', 'ti'];
export type Modo = 'simulacao' | 'real';
export type EstadoCartao = 'rodando' | 'sem_sinal' | 'falhou' | 'pausada' | 'fora_da_janela' | 'em_dia';
export type Frequencia = 'dias_uteis' | 'mensal' | 'manual';

export interface Agenda {
  frequencia: Frequencia;
  horarios: string[];
  dia_inicio?: number | null;
  dia_fim?: number | null;
  dia_util_inicio?: number | null;
  dia_mes?: number | null;
}

export interface Placar {
  execucoes: number;
  falhas: number;
  processados: number;
  ok: number;
  divergentes: number;
  aguardando: number;
}

export interface ExecucaoResumo {
  id: string;
  estado: 'rodando' | 'concluida' | 'falhou' | 'sem_sinal';
  modo: Modo;
  iniciada_em: string;
  terminada_em: string | null;
  processados: number;
  ok: number;
  divergentes: number;
  aguardando: number;
  mensagem: string | null;
}

export interface Cartao {
  id: string;
  codigo: string;
  nome: string;
  area: Area;
  descricao: string | null;
  modo: Modo;
  pausada: boolean;
  agenda: Agenda;
  estado: EstadoCartao;
  ultima: ExecucaoResumo | null;
  proxima_em: string | null;
  ultimo_reporte_em: string | null;
  mes: Placar;
  fila: number;
}

export interface Painel {
  mes: string;
  radar: Placar & { pendencias_abertas: number; resolvidas_no_mes: number; com_falha: number; rodando: number };
  itens: Cartao[];
}

export interface Etapa {
  chave: string;
  tipo: 'gatilho' | 'entrada' | 'etapa' | 'decisao' | 'saida';
  titulo: string;
  descricao: string | null;
}

export interface Ficha extends Cartao {
  etapas: Etapa[];
  etapas_ultima: Record<string, number>;
  chave: { prefixo: string; criada_em: string; ultimo_uso_em: string | null } | null;
  comandos_pendentes: { id: string; tipo: string; pedido_em: string }[];
  /** Entrega 2: quem recebe os avisos (vazio = quem tem a permissão) e as horas até o "sem sinal". */
  aviso_usuarios: { id: string; nome: string }[];
  horas_sem_sinal: number | null;
  horas_sem_sinal_padrao: number;
}

export interface Execucao extends ExecucaoResumo {
  automacao_id: string;
  id_externo: string;
  origem: string;
  codigo_saida: number | null;
  duracao_s: number | null;
}

export interface Pendencia {
  id: string;
  automacao_id: string;
  automacao_nome: string;
  tipo: string;
  titulo: string;
  detalhe: string | null;
  link: string | null;
  estado: 'aberta' | 'resolvida';
  responsavel_id: string | null;
  responsavel_nome: string | null;
  prazo: string | null;
  nota: string | null;
  resolvida_em: string | null;
  created_at: string;
  card_id: string | null;
  card_numero: number | null;
}

/** Entrega 2 (aba Resultados): link do que a execução gerou. */
export interface Resultado {
  id: string;
  automacao_id: string;
  execucao_id: string;
  execucao_iniciada_em: string;
  tipo: 'relatorio' | 'planilha' | 'arquivo' | 'pasta' | 'link';
  titulo: string;
  url: string;
  created_at: string;
}

export interface Feriado {
  id: string;
  data: string;
  nome: string;
}

export const COR_ESTADO: Record<EstadoCartao, 'verde' | 'azul' | 'perigo' | 'laranja' | 'neutro'> = {
  em_dia: 'verde',
  rodando: 'azul',
  sem_sinal: 'laranja',
  falhou: 'perigo',
  pausada: 'laranja',
  fora_da_janela: 'neutro',
};

/** Duração legível (segundos): "45 s", "3 min", "1 h 05 min". */
export function duracao(s: number | null | undefined): string {
  if (s === null || s === undefined) return '';
  if (s < 60) return `${s} s`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, '0')} min`;
}
